const DOLLARS = new Intl.NumberFormat('en-AU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * "$128.00" — the credits display string, shared by ProfilePage, UserMenu and
 * Agent Monitor so the surfaces can't drift on format. A credit sells for A$1,
 * so the dollar figure IS the credit count (ADR-0078 §1; decided 2026-10-03 —
 * never `credits × creditRateAud`, which is our cost and hides the margin).
 * `credits` is the priced value only — callers own how they render the
 * absent (unpriced, D13-03's null discipline) case, since ProfilePage says
 * "Not yet priced" and UserMenu omits the row content entirely.
 *
 * The ledger carries the ADR-0063 §6 fixed-point string at full precision
 * (12 decimal places) because it's re-priced from stored token counts, never
 * from a rounded display value. Rounding happens here, at render time only —
 * this is the one place both surfaces read, so neither can round differently.
 */
export function formatCreditsValue(credits: string): string {
  return `$${DOLLARS.format(Number(credits))}`;
}
